(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dealer-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('dealer-product-card')) return;

    class DealerProductCard extends HTMLElement {
      connectedCallback() {
        this.slider = this.querySelector('[data-dealer-slider]');
        this.slides = Array.from(this.querySelectorAll('.dealer-card__slide'));
        this.dots = Array.from(this.querySelectorAll('.dealer-card__dot'));
        this.prevBtn = this.querySelector('[data-dealer-prev]');
        this.nextBtn = this.querySelector('[data-dealer-next]');
        this.statusEl = this.querySelector('[data-dealer-status]');
        this.clickZone = this.querySelector('[data-dealer-open-zone]');
        this.currentIndex = 0;

        this._onDotClick = this._onDotClick.bind(this);
        this._onScroll = this._onScroll.bind(this);
        this._onPrev = this._onPrev.bind(this);
        this._onNext = this._onNext.bind(this);
        this._onZoneClick = this._onZoneClick.bind(this);
        this._onZoneKeydown = this._onZoneKeydown.bind(this);

        this.dots.forEach((dot) => dot.addEventListener('click', this._onDotClick));
        if (this.slider) this.slider.addEventListener('scroll', this._onScroll, { passive: true });
        if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
        if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);

        // Only the click-zone (title/desc/price/footer + the CTA button
        // nested inside it) opens the modal. The media box is untouched.
        if (this.clickZone) {
          this.clickZone.addEventListener('click', this._onZoneClick);
          this.clickZone.addEventListener('keydown', this._onZoneKeydown);
        }

        this._updateStatus();
      }

      disconnectedCallback() {
        this.dots.forEach((dot) => dot.removeEventListener('click', this._onDotClick));
        if (this.slider) this.slider.removeEventListener('scroll', this._onScroll);
        if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
        if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
        if (this.clickZone) {
          this.clickZone.removeEventListener('click', this._onZoneClick);
          this.clickZone.removeEventListener('keydown', this._onZoneKeydown);
        }
      }

      _onDotClick(event) {
        event.stopPropagation();
        this._goTo(parseInt(event.currentTarget.dataset.dotIndex, 10));
      }

      _onPrev(event) {
        event.stopPropagation();
        this._step(-1);
      }

      _onNext(event) {
        event.stopPropagation();
        this._step(1);
      }

      _step(delta) {
        if (!this.slides.length) return;
        const next = (this.currentIndex + delta + this.slides.length) % this.slides.length;
        this._goTo(next);
      }

      _goTo(index) {
        const slide = this.slides[index];
        if (slide && this.slider) {
          this.slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        this._setActive(index);
      }

      _onScroll() {
        if (!this.slider) return;
        const scrollLeft = this.slider.scrollLeft;
        let closest = 0;
        let closestDist = Infinity;
        this.slides.forEach((slide, i) => {
          const dist = Math.abs(slide.offsetLeft - scrollLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closest = i;
          }
        });
        this._setActive(closest);
      }

      _setActive(index) {
        this.currentIndex = index;
        this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
        this.dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-selected', String(i === index));
        });
        this._updateStatus();
      }

      _updateStatus() {
        if (this.statusEl && this.slides.length) {
          this.statusEl.textContent = 'Image ' + (this.currentIndex + 1) + ' of ' + this.slides.length;
        }
      }

      _onZoneClick() {
        this._openDealerModal();
      }

      _onZoneKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this._openDealerModal();
        }
      }

      _openDealerModal() {
        const data = Object.assign({}, this.dataset);
        document.dispatchEvent(
          new CustomEvent('dealer:card:open', {
            bubbles: true,
            detail: { product: data, triggerEl: this },
          })
        );
      }
    }

    customElements.define('dealer-product-card', DealerProductCard);
  })();
  } catch(e) { console.error(e); }
})();

})();
